module.exports = __webpack_public_path__ + "img/Bloque-05.bd08579e.png";